<h1 *header="Title; d9: '#block-pac-theme-pagetitle h1.title'; let title" class="page-header">{{ title }}</h1>

<app-signup-header></app-signup-header>

<app-progress-bar [bs4Class]="['my-3']" class="hidden-xs"></app-progress-bar>

<div *ngIf="HasPromo" id="promo-noted">
  Your promotional code ({{Promo}}) has been applied, and the discount will be shown on your checkout page before you pay!
</div>

<ng-container *ngIf="COVID$ | async">
  <p>To help you while you are not practicing during the pandemic, we are extending your membership for one month at no
    cost. <strong>This extension membership does not include insurance.</strong> When you're ready to go back to work, you can easily
    renew your previous fully-insured membership.</p>
</ng-container>

<ng-container *ngIf="Busy$ | async as Text">
  <div class="progress">
    <div class="progress-bar progress-bar-striped active" style="width: 100%">
      <strong>{{ Text }}</strong>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="(COVID$ | async) === covidStates.ready">
  <p class="text-center">
    <button class="btn btn-lg btn-success" [routerLink]="['/signup', 'selection', 'terms']">Continue</button>
  </p>
</ng-container>

<router-outlet></router-outlet>
